import React from "react";
import { Link } from "react-router-dom";

const ChallengesCommonHeader = ({ componentName = "" }) => {
  const menuItems = [
    {
      name: "Dashboard",
      path: "/admin/challenges/dashboard",
      key: "dashboard",
    },
    {
      name: "Challenges",
      path: "/admin/challenges/list",
      key: "challengelist",
    },
    {
      name: "Report",
      path: "/admin/challenges/globalreport",
      key: "fullreport",
    },
  ];

  return (
    <div className="inner-menu-container bg-white shadow-sm">
      <div className="container-fluid px-lg-5">
        <ul className="nav secondary-menu mw-100 flex-nowrap gap-xl-5 flex-fill fs-sm fw-semibold text-center border-0 text-nowrap overflow-auto">
          {menuItems.map((item) => (
            <li className="nav-item flex-fill" key={item.key}>
              <Link
                to={item.path}
                className={`d-block text-black px-2 px-sm-3 py-3 py-sm-4 position-relative ${
                  componentName === item.key ? "active" : ""
                }`}
              >
                {item.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ChallengesCommonHeader;
